// extracted by mini-css-extract-plugin
export default {"mainContainer":"Intro_mainContainer__9dBBG","img":"Intro_img__VjkR2","button":"Intro_button__mqT2B"};